import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * コープデリ職員認証済判定
 *
 * @export API通信成功時の処理
 * @class CheckAuthenticatedService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class CheckAuthenticatedService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof CheckAuthenticatedService
   */
  execute(successFunc: Function = null) {
    this.successFunc = successFunc;
    this.send('checkAuthenticated', new PlessRequest());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof CheckAuthenticatedService
   */
  success(data: any) {
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
